<template>
  <coverage-page 
    :customPageControl="pageControl" 
    :customDefaultForm="defaultForm" 
    :customNeedValidate="needValidate" 
  />
</template>
<script>
import { mapGetters } from "vuex";
import CoveragePage from "./components/CoveragePage.vue";
import { commonMixin } from "@/mixins/common";
export default {
  mixins: [commonMixin],
  name: "WomenBenefit",
  components: {
    CoveragePage,
  },
  data() {
    return {
      pageControl: {
        pageName: "婦女險",
        pageBlock: ["period", "formula", "maxCustom"],
        showUpper: true,
      },
      defaultForm: {
        unit_lower: 3
      },
      needValidate: {
        period_upper: false
      }      
    };
  },
  computed: {
    ...mapGetters(["BaseUrl"]),
  },
  watch: {},
  methods: {},
  mounted() {},
};
</script>
